document.addEventListener('DOMContentLoaded',()=>{
    if (location.pathname.includes('/products')) {
        const objectProductVariants = window.DATA_VARIANTS
        // variants stock
        let fullStock = document.querySelector('.full-stock')
        let inStock = document.querySelector('.in-stock')
        let outStock = document.querySelector('.out-stock')

        // drawer PDP
        const allItemTitleAdditionalInformation = document.querySelectorAll('.item__title')
        allItemTitleAdditionalInformation.forEach(itemTitle => {
            itemTitle.addEventListener('click', ()=>{
                itemTitle.nextElementSibling.classList.add('container__drawer-item--open')
                setTimeout(() => {
                    itemTitle.nextElementSibling.firstElementChild.classList.add('drawer-item__open')
                }, 200);
            })
            document.addEventListener('click', (evt)=>{
                if (evt.target.classList.contains('container__drawer-item') || evt.target.matches('.drawer-item__header a svg')) {
                    evt.preventDefault()
                    itemTitle.nextElementSibling.firstElementChild.classList.remove('drawer-item__open')
                    setTimeout(() => {
                        itemTitle.nextElementSibling.classList.remove('container__drawer-item--open')
                    }, 300);
                }
            })
        });

        handleStockAlert(Number(objectProductVariants.stock))

        function handleStockAlert(stock) {
            if (stock > 10 ) {
                hiddeStock(fullStock, outStock,inStock)
                fullStock.style.display = 'flex'
                return
            }
            if (stock < 10 && stock > 0 ) {
                hiddeStock(fullStock, outStock,inStock)
                inStock.style.display = 'flex'
                inStock.lastElementChild.textContent = `${stock} en stock`
                return
            }
            if (stock === 0) {
                hiddeStock(fullStock, outStock,inStock)
                outStock.style.display = 'flex'
                return
            }
          }

        openDrawerBlockInformation('.shipping')
        openDrawerBlockInformation('.payment')

        if (window.innerWidth <= 768) {
            const tableFirst = document.querySelector('.feature__table.main-feature .first tbody')
            const allTrTable = document.querySelectorAll('.feature__table.main-feature table tr')
            allTrTable.forEach( trTable => {
                tableFirst.appendChild(trTable)
            })
        }
    }

    if (location.pathname.includes('/collections') || location.pathname.includes('/search')) {
        // filter drawer actions
        //-- open
        const btnFilterMobile = document.querySelector('.mobile-facets__open-wrapper')
        btnFilterMobile.addEventListener('click', ()=>{
            setTimeout(() => {
                btnFilterMobile.nextElementSibling.querySelector('.mobile-facets__inner').style.transform = 'translate(0)'
            }, 300);
        })

        //-- btn filters drawers
        const allButtonsFilter = document.querySelectorAll('.mobile-facets__summary .collapasable')
        allButtonsFilter.forEach(buttonFilter => {
            buttonFilter.addEventListener('click', ()=>{
                const nextElement = buttonFilter.nextElementSibling
                nextElement.classList.toggle('open')
                if (nextElement.classList.contains('open')) {
                    nextElement.style.height = `${nextElement.scrollHeight + 10}px`
                }else{
                    nextElement.style.height = `0px`
                }
            })
        });

        // shortText('.collection-hero__description', 150)
    }

    // sort-by function

    const allSortByBtn = document.querySelectorAll('.filter-sort-by__title')
    if (allSortByBtn) {
        allSortByBtn.forEach(btn => {
            btn.addEventListener('click',(evt)=>{
                evt.preventDefault()
                btn.firstElementChild.classList.toggle('active')
                if (btn.firstElementChild.classList.contains('active')) {
                    btn.firstElementChild.lastElementChild.classList.add('rotate')
                }else{
                    btn.firstElementChild.lastElementChild.classList.remove('rotate')
                }
                btn.nextElementSibling.classList.toggle('active')
                if (btn.nextElementSibling.classList.contains('active')) {
                    btn.nextElementSibling.style.height = `${btn.nextElementSibling.scrollHeight}px`
                }else{
                    btn.nextElementSibling.style.height = `0`
                }
            })
        });
        const allBtnOption = document.querySelectorAll('.filter-sort-by__items .item')

        const selectOption = document.querySelector('.sort--option__vertical')

        if (selectOption) {
            const selectOptionValue = selectOption.value
            const btnOptionCurrentValue = [...allBtnOption].find(item => item.dataset.value === selectOptionValue)
            btnOptionCurrentValue.firstElementChild.lastElementChild.classList.add('active')
            btnOptionCurrentValue.classList.add('item--color')
            document.addEventListener('click',(evt)=>{
                if (evt.target.matches('.items li')) {
                    evt.preventDefault()
                    const selectOption = document.querySelector('.sort--option__vertical')
                    let btnOption = evt.target
                    const itemContainColor = document.querySelector('.filter-sort-by__items .item--color')
                    if (itemContainColor && itemContainColor.classList.contains('item--color')) itemContainColor.classList.remove('item--color')
                    btnOption.classList.toggle('item--color')
                    const optionActive = document.querySelector('.items li .active')
                    btnOption.firstElementChild.lastElementChild.classList.toggle('active')
                    if (optionActive) {
                        optionActive.classList.remove('active')
                    }
                    localStorage.setItem('sortBy', btnOption.dataset.valueOption)
                    let btnOptionSelectedIndex = btnOption.dataset.optionIndex
                    selectOption.options.item(btnOptionSelectedIndex).selected = 'selected'
                    selectOption.form.dispatchEvent(new Event('input'))
                }
            })
        }
    }

    if (location.href.includes('pages/reclamos')) {
        const sectionActive = document.querySelector('[data-section-tab-active]')
        const allSection = document.querySelectorAll('[data-section-type]')
        allSection.forEach(section => {
            if (section.dataset.sectionType != sectionActive.dataset.sectionTabActive ) {
                section.style.display = 'none'
            }
            if (section.dataset.sectionType == sectionActive.dataset.sectionTabActive ){
                section.classList.add('section--active')
            }
        });
        const allTab = document.querySelectorAll('.tab')
        let tabActive = [...allTab].find( tab => tab.dataset.tabTitle == sectionActive.dataset.sectionTabActive)
        tabActive.classList.add('tab--active')

        allTab.forEach(tab => {
            tab.addEventListener('click', (evt)=>{
                evt.preventDefault()
                const tabActived = document.querySelector('.tab--active')
                if (tab.dataset.tabTitle != tabActived.dataset.tabTitle) {
                    tabActived.classList.remove('tab--active')
                    tab.classList.add('tab--active')
                    allSection.forEach(section => {
                        if (section.dataset.sectionType != tab.dataset.tabTitle) {
                            section.style.display = 'none'
                        }else{
                            section.style.display = 'block'
                        }
                    })
                }
            })
        });
    }



})

function hiddeStock(fullStock,outStock,inStock) {
    fullStock.style.display = 'none'
    outStock.style.display = 'none'
    inStock.style.display = 'none'
}

function openDrawerBlockInformation(classItem) {
    const btnItem = document.querySelector(classItem)
    if(!!!btnItem) return
    btnItem.addEventListener('click', ()=>{
        btnItem.nextElementSibling.classList.add('container__drawer-item--open')
        setTimeout(() => {
            btnItem.nextElementSibling.firstElementChild.classList.add('drawer-item__open')
        }, 200);
    })
    document.addEventListener('click', (evt)=>{
        if (evt.target.classList.contains('container__drawer-item') || evt.target.matches('.drawer-item__header a svg')) {
            evt.preventDefault()
            btnItem.nextElementSibling.firstElementChild.classList.remove('drawer-item__open')
            setTimeout(() => {
                btnItem.nextElementSibling.classList.remove('container__drawer-item--open')
            }, 300);
        }
    })
}

function shortText(containerClass, textLength) {
    let allContainers = document.querySelectorAll(containerClass )
    allContainers.forEach(container => {
        if (container.innerHTML.length > textLength) {
            container.textContent = container.innerText.substring(0,textLength) + "..."
        }
    })
}
